module.exports = __webpack_public_path__ + "static/nxrt-rail3-78c0b7469f165db2bbff9fe40ac52491.jpg";